function cartLoadPage(el) {
	$.getJSON('/cart.js').then(
		function(cart) {
			var cartItems = cart.items;
			for (let i = 0; i < cartItems.length; i++) {
				/* Inventory */
				var iQuantity = parseInt(cartItems[i].quantity);
				var iOrder = '[data-order-option="' + cartItems[i].properties['ORDER'] + '"]';
				var iProductID = '[data-product-id="'+ cartItems[i].id + '"]';
				var maxInventory = $(iOrder).find(iProductID).find('#quantity-variants').attr('inventory');
				if (iQuantity <= maxInventory) {
					var calcInventoryLabel = maxInventory - iQuantity;
					$(iOrder).find(iProductID).find('[js-product-max-inventory]').empty().append(calcInventoryLabel);
					$(iOrder).find(iProductID).find('#quantity-variants').attr('max', calcInventoryLabel);
				}else if (iQuantity > maxInventory){
					$(iOrder).find(iProductID).find('[js-product-max-inventory]').empty().append(0);
					$(iOrder).find(iProductID).find('#quantity-variants').attr('max', 0);
				}
			}
		}
	);
}

document.addEventListener('DOMContentLoaded', () => {
	cartLoadPage();
});